<template>
    <teleport to="body">
        <AriaFocus root="body" class="relative" :style="{ zIndex: zIndex }">
            <TrapFocus :return-focus="true">
                <transition
                    appear
                    enter-active-class="transition ease-out duration-200"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="transition ease-in duration-300"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                    @after-enter="state.request('open')"
                    @after-leave="state.request('closed')"
                >
                    <LockBodyScroll v-if="state.is('opening') || state.is('open')">
                        <div
                            ref="maskEl"
                            v-mounted="($el) => $emit('mounted', $el)"
                            class="ModalMask"
                            :class="maskClass"
                            :style="maskStyle"
                            @mousedown.left.self="$emit('click', $event)"
                        >
                            <transition
                                appear
                                enter-active-class="transition ease-out duration-300 max-h-screen overflow-y-hidden"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-150 max-h-screen overflow-y-hidden"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                            >
                                <slot v-if="state.is('opening') || state.is('open')" />
                            </transition>
                        </div>
                    </LockBodyScroll>
                </transition>
            </TrapFocus>
        </AriaFocus>
    </teleport>
</template>

<style>
.ModalMask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px;
    -webkit-overflow-scrolling: touch;
}

.ModalMask.--fullscreen {
    padding: 0;
}
</style>

<script type="text/babel">
import AriaFocus from './AriaFocus'
import HasEventListeners from '@makeabledk/vue-ui/mixins/has-event-listeners'
import LockBodyScroll from './LockBodyScroll'
import Mounted from '@makeabledk/vue-ui/directives/mounted'
import TrapFocus from '@makeabledk/vue-ui/components/trap-focus'

export default {
    components: { AriaFocus, TrapFocus, LockBodyScroll },

    directives: { Mounted },

    mixins: [HasEventListeners],

    inject: ['state'],

    props: {
        maskClass: {
            default() {
                return ''
            },
        },

        color: {
            default() {
                return [26, 32, 44]
            },
        },

        opacity: {
            default: 0.6,
        },

        zIndex: {
            default: 1040,
        },
    },

    emits: ['click', 'mounted'],

    computed: {
        maskStyle() {
            return {
                backgroundColor: `rgba(${this.color.join(',')}, ${this.opacity})`,
            }
        },
    },
}
</script>
